import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import { Layout, Loader, ErrorBoundary } from "components";
import { HomePage } from "pages";

const SearchPage = lazy(() =>
 import("pages").then((m) => ({ default: m.SearchPage })),
);
const RestaurantPage = lazy(() =>
 import("pages").then((m) => ({ default: m.RestaurantPage })),
);
const DealPage = lazy(() =>
 import("pages").then((m) => ({ default: m.DealPage })),
);
const ReviewsPage = lazy(() =>
 import("pages").then((m) => ({ default: m.ReviewsPage })),
);
const FavoritesPage = lazy(() =>
 import("pages").then((m) => ({ default: m.FavoritesPage })),
);
const NotificationsPage = lazy(() =>
 import("pages").then((m) => ({ default: m.NotificationsPage })),
);
const OrdersPage = lazy(() =>
 import("pages").then((m) => ({ default: m.OrdersPage })),
);
const NotFoundPage = lazy(() =>
 import("pages").then((m) => ({ default: m.NotFoundPage })),
);

const LazyRoute = ({ children }) => (
 <ErrorBoundary>
  <Suspense fallback={<Loader />}>
   {children}
  </Suspense>
 </ErrorBoundary>
);

export const router = createBrowserRouter([
 {
  path: "/",
  element: <Layout />,
  children: [
   {
    index: true,
    element: (
     <ErrorBoundary>
      <HomePage />
     </ErrorBoundary>
    ),
   },
   { path: "search", element: <LazyRoute><SearchPage /></LazyRoute> },
   { path: "restaurant/:restaurantId", element: <LazyRoute><RestaurantPage /></LazyRoute> },
   { path: "restaurant/:restaurantId/deal/:dealId", element: <LazyRoute><DealPage /></LazyRoute> },
   { path: "profile/reviews", element: <LazyRoute><ReviewsPage /></LazyRoute> },
   { path: "profile/favourites", element: <LazyRoute><FavoritesPage /></LazyRoute> },
   { path: "profile/notifications", element: <LazyRoute><NotificationsPage /></LazyRoute> },
   { path: "profile/orders", element: <LazyRoute><OrdersPage /></LazyRoute> },
   { path: "*", element: <LazyRoute><NotFoundPage /></LazyRoute> },
  ],
 },
]);

//TODO: SEO
//TODO: Add better loading skeleton components instead of generic loader
